<template>
    <TheFooter>
        <div>
            <span class="ml-1">&copy; 2023 Sinar Mutiara Cell. {{ version }}</span>
        </div>
    </TheFooter>
</template>
<script>
import { Footer as TheFooter } from '@coreui/vue'
export default {
    name: 'DefaultFooter',
    components: {
        TheFooter
    },
    data() {
        return {
            version: localStorage.getItem("version")
        }
    }
}
</script>
